import { render, staticRenderFns } from "./MeVaBe.vue?vue&type=template&id=683f12a6&scoped=true&"
import script from "./MeVaBe.vue?vue&type=script&lang=js&"
export * from "./MeVaBe.vue?vue&type=script&lang=js&"
import style0 from "./MeVaBe.vue?vue&type=style&index=0&id=683f12a6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "683f12a6",
  null
  
)

export default component.exports